import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { confirmReportResolution } from '@/services/confirm-report-resolution'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export const useConfirmReportResolution = (
  treatment: Treatment,
  culture: Culture,
  diagnosisId: string,
  reportId: string,
) => {
  const mutation = useMutation({
    mutationFn: () =>
      confirmReportResolution(treatment, culture, diagnosisId, reportId),
    onError: (error: Error) => {
      toast.error(
        `Ocorreu um erro ao enviar sua solicitação. Tente novamente. [${error?.message}]`,
      )
    },
  })

  return mutation
}
